import {externalBaseApi, extractData} from "../../api/axiosConfig";

export const getAllLicenses = () =>
    externalBaseApi
        .get("/license")
        .then(extractData);

export const getLicenseObligationData = cdpvId =>
    externalBaseApi
        .get("/license/obligationData", {
            params: {
                my_cdpv_id: cdpvId
            }
        })
        .then(extractData);

export const addLicense = data =>
    externalBaseApi
        .post("/license", data)
        .then(extractData);

export const editLicense = (licenseId, data) =>
    externalBaseApi
        .put(`/license/${licenseId}`, data)
        .then(extractData);

export const deleteLicense = licenseId =>
    externalBaseApi
        .delete(`/license/${licenseId}`)
        .then(extractData);

export const uploadLicense = license =>
    externalBaseApi
        .post("/license/upload", license)
        .then(extractData);

export const getLicensees = () =>
    externalBaseApi
        .get("/license/licensee")
        .then(extractData);

export const getMarkets = () =>
    externalBaseApi
        .get("/license/market")
        .then(extractData);

export const getTerritories = () =>
    externalBaseApi
        .get("/license/territory")
        .then(extractData);

export const licenseSearch = request =>
    externalBaseApi
        .post("/license/licenseSearch", request)
        .then(extractData);

//
// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
//
// export const getAllLicenses = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/license`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getLicenseObligationData = (my_cdpv_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/license/obligationData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdpv_id: my_cdpv_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
//
// export   const addLicense = abcd =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/license`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const editLicense = (selectorLicenseId, data) =>
//     axios.put(`${BASE_URL}/ExternalData/api/contramatic/license/${selectorLicenseId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteLicense = selectorLicenseId =>
//     axios.delete(`${BASE_URL}/ExternalData/api/contramatic/license/${selectorLicenseId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export   const uploadLicense = (license) =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/license/upload`,license, {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             }
//         })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 console.log(error.request);
//             } else {
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getLicensees= () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/license/licensee`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getMarkets = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/license/market`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getTerritories = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/license/territory`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const licenseSearch = (request) =>
//
//     axios.post(
//         `${BASE_URL}/ExternalData/api/contramatic/license/licenseSearch`,
//         request,
//         // CONFIG
//         {
//             headers: {
//                 Authorization:
//                     'Bearer ' + localStorage.getItem('token'),
//                 'Content-Type': 'application/json'
//             }
//         }
//     )
//
//         .catch(function (error) {
//
//             if (error.response) {
//
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//
//             } else if (error.request) {
//
//                 console.log(error.request);
//
//             } else {
//
//                 console.log('Error', error.message);
//
//             }
//
//             console.log(error.config);
//
//         });